module.exports = __webpack_public_path__ + "img/screen-dashboard.f67ffa54.png";